// Kaily OS — shared helpers for the /os cockpit
import axios from "axios";
import { getStudioPassword } from "@/lib/studioAuth";

export const OS_API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function osHeaders() {
    return { "X-Studio-Password": getStudioPassword() };
}

export const osGet = (path) => axios.get(`${OS_API}${path}`, { headers: osHeaders() });
export const osPost = (path, body) => axios.post(`${OS_API}${path}`, body ?? null, { headers: osHeaders() });
export const osPut = (path, body) => axios.put(`${OS_API}${path}`, body, { headers: osHeaders() });

export const t = (lang, en, cn) => (lang === "cn" ? cn : en);

export const OFFER_LABELS = {
    ig_monthly: { en: "IG Monthly AI Content", cn: "IG AI 内容系统(月付)" },
    reels_1: { en: "1 Reel Shoot · RM388", cn: "1 支 Reel 拍摄 · RM388" },
    reels_2: { en: "2 Reels Shoot · RM788", cn: "2 支 Reels 拍摄 · RM788" },
    reels_3: { en: "3 Reels Shoot · RM1100", cn: "3 支 Reels 拍摄 · RM1100" },
    product_video: { en: "Product Video · RM480", cn: "产品视频 · RM480" },
    starter: { en: "IG Monthly AI Content", cn: "IG AI 内容系统" },
    standard: { en: "IG Monthly AI Content", cn: "IG AI 内容系统" },
    premium: { en: "IG Monthly AI Content", cn: "IG AI 内容系统" },
    shoot: { en: "Reels Shoot", cn: "Reels 拍摄" },
};
export const OFFER_PRICES = { ig_monthly: 348, reels_1: 388, reels_2: 788, reels_3: 1100, product_video: 480 };

export const offerLabel = (key, lang) => {
    const o = OFFER_LABELS[key];
    return o ? (lang === "cn" ? o.cn : o.en) : key;
};

export function scoreColor(v) {
    if (v >= 85) return "#7BA05B";
    if (v >= 70) return "#D4A574";
    return "#C0604A";
}
